module.exports = __webpack_public_path__ + "static/media/LogoDashboard.8be8e5b0.svg";